import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import React, { useContext } from 'react';
import DesktopProfileTopDisplay728x90 from '@wix/da-ads/pkg/adunits/DesktopProfileTopDisplay728x90';
import DesktopProfileBottomDisplay728x90 from '@wix/da-ads/pkg/adunits/DesktopProfileBottomDisplay728x90';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';

import s from './LeaderboardWrapper.scss';

export interface Props {
  children: React.ReactNode;
  adSafety: string;
}

const LeaderboardWrapper: React.FC<Props> = ({ children, adSafety }) => {
  const isMobile = useContext(MobileContext);
  const { adsEnabled } = useContext(SessionContext);
  const ads_nitro = useFlag('ads_nitro');

  if (isMobile || !ads_nitro || !adsEnabled) {
    return <>{children}</>;
  }

  return (
    <>
      <div className={s['top']}>
        <ErrorBoundary debugComponent="DesktopProfileTopDisplay728x90">
          <DesktopProfileTopDisplay728x90 safety={adSafety} />
        </ErrorBoundary>
      </div>
      {children}
      <div className={s['bottom']}>
        <ErrorBoundary debugComponent="DesktopProfileBottomDisplay728x90">
          <DesktopProfileBottomDisplay728x90 safety={adSafety} />
        </ErrorBoundary>
      </div>
    </>
  );
};
LeaderboardWrapper.displayName = 'LeaderboardWrapper';

export default LeaderboardWrapper;
